import { getPricePerShare, type LotInput } from './types';

export const hasInconsistentLotPricing = ({ lots }: { lots: LotInput[] }): boolean => {
  let firstPrice: number | undefined;
  for (const lot of lots) {
    const price = getPricePerShare(lot);
    if (price === undefined) continue;
    if (firstPrice === undefined) {
      firstPrice = price;
    } else if (Math.abs(price - firstPrice) > 0.01) {
      return true;
    }
  }
  return false;
};
